// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ytGb{all:unset;align-items:center;color:var(--main-blue);cursor:pointer;display:inline-flex;gap:8px}.rD7o{--s:20px;height:20px;height:var(--s);width:20px;width:var(--s)}._7BjJ{color:currentColor;font-family:\"Roboto\",sans-serif!important;font-size:14px;font-style:normal;font-weight:400;letter-spacing:.17px;line-height:20px;-webkit-user-select:none;-moz-user-select:none;user-select:none}.VXPp{display:flex;flex-direction:column;gap:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionSidebarTextExtraButton": "ytGb",
	"actionSidebarTextExtraButtonIcon": "rD7o",
	"actionSidebarTextExtraButtonLabel": "_7BjJ",
	"actionSidebarTextContainer": "VXPp"
};
module.exports = ___CSS_LOADER_EXPORT___;
